export default "__VITE_ASSET__ugyKxO$u__"